import { useQuery } from 'react-query';
import * as api from '../../services/api';

export const HELP_DESK_UNREAD_COUNT_QUERY_KEY = 'helpDeskUnreadCount';

const useHelpDeskUnreadCount = ({ accountId }) => {
  const { data, isLoading } = useQuery(
    [HELP_DESK_UNREAD_COUNT_QUERY_KEY, accountId],
    () => api.fetchHelpDeskUnreadCount({ accountId }),
    {
      enabled: !!accountId,
      refetchInterval: 60 * 1000,
      staleTime: 30 * 1000
    }
  );

  return { count: data?.data?.count ?? 0, isLoading };
};

export default useHelpDeskUnreadCount;
